<template>
    <div class="setting-page-content-wrapper features">
        <div class="page-header">
            <div class="title">{{ $t("settings.features") }}</div>
            <div class="subtitle">{{ $t("settings.featuresSubtitles") }}</div>
        </div>
        <section>
            <div class="features">
                <FeatureItem
                    :title="feature.title"
                    :description="feature.description"
                    v-for="feature in features"
                    :value="readValue(feature.id)"
                    @input="setValue(feature.id, $event)"
                    :key="feature.id"
                    :icon="feature.icon"
                />
            </div>
        </section>
    </div>
</template>

<script>
import { mapState } from "vuex";
import log2 from "../../../../../utils/log2";
import WirelessKeyboardIcon from "../../../../../components/svg/icons/WirelessKeyboardIcon.vue";
import FeatureItem from "../../components/FeatureItem.vue";
import PaperShredderIcon from "../../../../../components/svg/icons/PaperShredderIcon.vue";

const log = log2("Settings/Features");

export default {
    name: "Features",
    components: {
        WirelessKeyboardIcon,
        FeatureItem,
        PaperShredderIcon,
    },
    props: {
        updateSettings: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            features: [
                {
                    title: this.$t("message.featuresTitle1"),
                    description: this.$t("message.featuresDesc1"),
                    icon: "DepartmentIcon",
                    id: "subject",
                },
                {
                    title: this.$t("message.featuresTitle2"),
                    description: this.$t("message.featuresDesc2"),
                    icon: "QueueIcon",
                    id: "queueNumberVisible",
                },
                {
                    title: this.$t("message.featuresTitle3"),
                    description: this.$t("message.featuresDesc3"),
                    icon: "BannedWordIcon",
                    id: "bannedWordMarking",
                },
                {
                    title: this.$t("message.featuresTitle4"),
                    description: this.$t("message.featuresDesc4"),
                    icon: "TicketShow",
                    id: "ticketShow",
                },
                {
                    title: this.$t("message.featuresTitle5"),
                    description: this.$t("message.featuresDesc5"),
                    icon: "voiceCall",
                    id: "audiocallEnabled",
                },
                {
                    title: this.$t("message.featuresTitle6"),
                    description: this.$t("message.featuresDesc6"),
                    icon: "videoCallIcon",
                    id: "videocallEnabled",
                },
                {
                       title: this.$t("message.featuresTitle7"),
                    description: this.$t("message.featuresDesc7"),
                    icon: "soundRecordingIcon",
                    id: "agentVoiceRecordEnabled",
                },
                {
                    title: this.$t("message.featuresTitle8"),
                    description: this.$t("message.featuresDesc8"),
                    icon: "microphoneIcon",
                    id: "visitorVoiceRecordEnabled",
                },
                /*{
                    title: this.$t("message.featuresTitle9"),
                    description: this.$t("message.featuresDesc9"),
                    icon: "automaticCallTransfer",
                    id: "autoTake",
                },*/
                {
                    title: this.$t("message.featuresTitle10"),
                    description: this.$t("message.featuresDesc10"),
                    icon: "speechIcon",
                    id: "privateChatEnabled",
                },
                {
                    title: this.$t("message.featuresTitle11"),
                    description: this.$t("message.featuresDesc11"),
                    icon: "representativeFile",
                    id: "agentFileSendEnabled",
                },
                {
                    title: this.$t("message.featuresTitle12"),
                    description: this.$t("message.featuresDesc12"),
                    icon: "fileIcon",
                    id: "visitorFileSendEnabled",
                },
                {
                    title: this.$t("message.featuresTitle13"),
                    description: this.$t("message.featuresDesc13"),
                    icon: "customerRepresentativeIcon",
                    id: "visitorWriteEmptyChat",
                },
                {
                    title: this.$t("message.featuresTitle14"),
                    description: this.$t("message.featuresDesc14"),
                    icon: "secretMessageIcon",
                    id: "disableAgentSystemMessages",
                },
                {
                    title: this.$t("message.featuresTitle15"),
                    description: this.$t("message.featuresDesc15"),
                    icon: "PaperShredderIcon",
                    id: "visitorGDPRDeleteEnabled",
                },
                {
                    title: this.$t("message.featuresTitle16"),
                    description: this.$t("message.featuresDesc16"),
                    icon: "messageIcon",
                    id: "visitorConnectionEventSystemMessageEnabled",
                },
                {
                    title: this.$t("message.featuresTitle17"),
                    description: this.$t("message.featuresDesc17"),
                    icon: "translationIcon",
                    id: "autoTranslate",
                },
                {
                    title: this.$t("message.featuresTitle18"),
                    description: this.$t("message.featuresDesc18"),
                    icon: "automaticLoginIcon",
                    id: "visitorAutoLogin",
                },
                {
                    title: this.$t("message.featuresTitle19"),
                    description: this.$t("message.featuresDesc19"),
                    icon: "visitorLocationIcon",
                    id: "visitorLocationEnabled",
                },
                {
                    title: this.$t("message.featuresTitle20"),
                    description: this.$t("message.featuresDesc20"),
                    icon: "locationIcon",
                    id: "customerLocationEnabled",
                },
                /* {
                    title: this.$t("message.customerAutoMergeEnabled"),
                    description: this.$t("message.customerAutoMergeEnabledDesc"),
                    icon: "MergeIcon",
                    id: "visitorAutoMergeEnabled",
                },*/
                {
                    title: this.$t("message.featuresTitle21"),
                    description: this.$t("message.featuresDesc21"),
                    icon: "ChatAiIcon",
                    id: "chatAiCopilot",
                },
                /*{
                    title: this.$t("message.featuresTitle22"),
                    description: this.$t("message.featuresDesc22"),
                    icon: "QueueIcon",
                    id: "autoAssignForcesQueueNoOwnerContacts",
                },*/
                {
                    title: this.$t("message.featuresTitle23"),
                    description: this.$t("message.featuresDesc23"),
                    icon: "visitorClearIcon",
                    id: "maskSensitiveInfo",
                },
            ],
        };
    },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
        }),
    },
    methods: {
        readValue(id) {
            log("readValue", id, this.settings[id]);
            if (["customerClientLanguageDetect", "subject", "autoTake", "writing", "bannedWord"].includes(id)) {
                return this.settings[id] == true;
            } else {
                return this.settings[id];
            }
        },
        setValue(id, value) {
            this.updateSettings(id, value);
        },
    },
    mounted() {},
    watch: {},
};
</script>

<style scoped lang="scss">
.features {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
</style>
